module.exports = __webpack_public_path__ + "static/media/ко.e005bdbb.mp3";